import IconWrapper, {
  IconWrapperProps,
} from "@repo/ui/src/components/IconWrapper";

const LeftArrow = ({ width, ...rest }: IconWrapperProps) => (
  <IconWrapper
    width={width || "20px"}
    viewBox="0 0 24 24"
    {...rest}
  >
    <path
      fill="currentColor"
      d="M3.29,12.71l7,7A1,1,0,0,0,11,20a1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.42L6.41,13H21a1,1,0,0,0,0-2H6.41l5.3-5.29a1,1,0,1,0-1.42-1.42l-7,7a1,1,0,0,0-.21.33.92.92,0,0,0,0,.76A1,1,0,0,0,3.29,12.71Z"
    />
  </IconWrapper>
);

export default LeftArrow;
